// extracted by css-extract-rspack-plugin
var _1 = "notice-xF4Z09";
var _2 = "prompt-vymZk4";
export { _1 as "notice", _2 as "prompt" }
